export const showAddBankModal = () => {
    return {
      type: "SHOW_ADD_BANK_MODAL",
    };
  };
  
  export const hideAddBankModal = () => {
    return {
      type: "HIDE_ADD_BANK_MODAL",
    };
  };
  